module.exports = __webpack_public_path__ + "static/media/Kenya.48a40eae.png";